import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AdminService } from 'src/app/Service/admin.service';
import { AuthService } from 'src/app/service/auth.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-graph-config-report-name',
  templateUrl: './graph-config-report-name.component.html',
})
export class GraphConfigReportNameComponent implements OnInit {
  Formula: string = '';
  ParameterList = [];
  ReportTimingForm: FormGroup;
  EmailTimingForm: FormGroup;
  EnergyMeterList = [];
  errorMsg: string = '';
  successMsg: string = '';
  errorMsg1: string = '';
  successMsg1: string = '';
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };
  GraphConfigList: any = [];
  GraphConfigId: number;
  GraphConfigData: any;
  selectedtimeduration: any = 'Daily'
  selectedreporttiming: any;
  selectedscheduletype: any;
  selecteddayspan: any;
  selectedemailtime: any;
  selectedemailday: any;
  selectedemaildate: any;
  dayspanflag: any = true
  emailtimeflag: any = true
  emaildayflag: any = false
  emaildateflag: any = false
  EmailConfigList: any = []
  dateOptions = Array.from({ length: 30 }, (_, i) => i + 1);

  constructor(public adminService: AdminService, public dialogRef: MatDialogRef<GraphConfigReportNameComponent>, private formBuilder: FormBuilder, private authService: AuthService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.ReportTimingForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    this.ReportTimingForm = this.formBuilder.group({
      TimeDuration: ['', [Validators.required]],
      FromTime: [''],
      ToTime: [''],
      Interval: [''],
      DaySpan: [''],
      GraphConfigName: ['', [Validators.required]]
    });
    this.EmailTimingForm = this.formBuilder.group({
      ReportTiming: ['', [Validators.required]],
      ScheduleType: [''],
      DaySpan: [''],
      EmailTime: [''],
      EmailDate: ['', [Validators.required]],
      EmailDay: ['', [Validators.required]],
      EmailIds: ['', [Validators.required]]
    });
    this.ReportTimingForm.valueChanges.subscribe(
      value => this.displayMessage = this.genericValidator.processMessages(this.ReportTimingForm, true)

    );
    this.EmailTimingForm.valueChanges.subscribe(
      value => this.displayMessage = this.genericValidator.processMessages(this.EmailTimingForm, true)

    );
    this.GraphConfigData = this.data.GraphConfigData;
    this.GraphConfigId = this.data.data
    this.getalldata();
  }

  Close() {
    this.dialogRef.close();
  }
  getalldata() {
    this.adminService.ReportDatabyGraphConfigId(this.data.GraphConfigId, localStorage.getItem("CompanyIdForUC")).subscribe(
      (result) => {
        this.GraphConfigList = result
      }
    )
    this.adminService.CustomEmailDatabyGraphConfigId(this.data.GraphConfigId, localStorage.getItem("CompanyIdForUC")).subscribe(
      (result) => {
        this.EmailConfigList = result
      }
    )
  }
  DeleteGraphConfigData(i) {
    this.errorMsg = "";
    this.ParameterList.splice(i, 1);
    this.GraphConfigList.splice(i, 1);
  }
  DeleteCustomEmailConfigData(i) {
    this.errorMsg = "";
    this.EmailConfigList.splice(i, 1);
    // this.GraphConfigList.splice(i, 1);
  }
  checkFormValidity(): void {
    Object.keys(this.ReportTimingForm.controls).forEach(key => {
      const control = this.ReportTimingForm.get(key);
      if (control && control.invalid) {
        const errors = control.errors;
        if (errors) {
        }
      }
    });
  }
  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }
  validateReportTimingForm() {
    const requiredFields = [
      // { key: 'GraphConfigName', message: 'Please enter valid Report Name !!' },
      { key: 'FromTime', message: 'Please select From Time !!' },
      { key: 'ToTime', message: 'Please select To Time !!' },
      { key: 'Interval', message: 'Please select Interval !!' },
      // { key: 'DaySpan', message: 'Please select DaySpan !!' },
      { key: 'TimeDuration', message: 'Please select Time Duration !!' }
    ];
    for (const field of requiredFields) {
      if (!this.ReportTimingForm.value[field.key]) {
        this.errorMsg = field.message;
        return false;
      }
    }
    return true;
  }
  validateEmailTimingForm() {
    const requiredFields = [
      { key: 'ReportTiming', message: 'Please select Report Timing !!' },
      { key: 'ScheduleType', message: 'Please select Schedule Type !!' },
      { key: 'DaySpan', message: 'Please select Day Span !!' },
      { key: 'EmailDate', message: 'Please select Email Date !!' },
      { key: 'EmailDate', message: 'Please select Email Date !!' },
      { key: 'EmailDay', message: 'Please select Email Day !!' },
      { key: 'EmailIds', message: 'Please enter Email Ids !!' }
    ];

    for (const field of requiredFields) {
      if (!this.EmailTimingForm.value[field.key]) {
        this.errorMsg = field.message;
        return false;
      }
    }
    return true;
  }


  AddRegisters() {
    this.successMsg = ""
    this.errorMsg = ""
    if (this.ReportTimingForm.value.Interval && this.ReportTimingForm.value.TimeDuration == "Daily") {
      if (typeof (this.ReportTimingForm.value.Interval) == 'object') {
        this.ReportTimingForm.value.Interval = formatDate(this.ReportTimingForm.value.Interval, 'HH:mm', 'en');
      }
      // this.ReportTimingForm.value.Interval = formatDate(this.ReportTimingForm.value.Interval, 'HH:mm', 'en');
    }
    if (typeof (this.ReportTimingForm.value.ToTime) == 'object') {
      this.ReportTimingForm.value.ToTime = formatDate(this.ReportTimingForm.value.ToTime, 'HH:mm', 'en');
    }
    if (this.ReportTimingForm.value.TimeDuration != "Daily") {
      this.ReportTimingForm.value.Interval = "-"
    }
    if (this.ReportTimingForm.value.TimeDuration == "Hourly") {
      this.ReportTimingForm.value.Interval = "01:00"
    }

    if (!this.validateReportTimingForm()) {
      return;
    }
    var flag
    this.GraphConfigList.forEach(element => {
      element.GraphConfigName == this.ReportTimingForm.value.GraphConfigName ? flag = true : false
    });
    if (flag) {
      this.errorMsg = "This Report Name already exists !!"
      return
    }
    this.errorMsg = '';
    this.successMsg = '';
    this.errorMsg1 = '';
    this.successMsg1 = '';
    let newobj = {
      GraphConfigId: this.data.GraphConfigId,
      FromTime: this.ReportTimingForm.value.FromTime,
      ToTime: this.ReportTimingForm.value.ToTime,
      Interval: this.ReportTimingForm.value.Interval,
      // DaySpan: this.ReportTimingForm.value.DaySpan ? this.ReportTimingForm.value.DaySpan : 0,
      DaySpan: this.selectedtimeduration == 'Daily' ? (this.ReportTimingForm.value.DaySpan ? this.ReportTimingForm.value.DaySpan : 0) : 0,

      GraphConfigName: this.ReportTimingForm.value.GraphConfigName,
      TimeDuration: this.ReportTimingForm.value.TimeDuration,
      UserId: +localStorage.getItem('UserId'),
      CompanyId: localStorage.getItem('CompanyIdForUC')
    }
    this.GraphConfigList.push(newobj)
    this.ReportTimingForm.value.GraphConfigName = ""
    this.ReportTimingForm.value.FromTime = ""
    this.ReportTimingForm.value.ToTime = ""
    this.ReportTimingForm.value.Interval = ""
    this.ReportTimingForm.value.TimeDuration = ""
    this.ReportTimingForm.value.DaySpan = ""
  }

  calculateNextSchedule(
    emailTime: string,
    scheduleType: string,
    daySpan: number,
    selectedEmailDay?: string,
    selectedEmailDate?: number
  ): string {
    const currentDate = new Date();

    // Split the EmailTime to get hours and minutes
    const [hours, minutes] = emailTime.split(':').map(Number);

    // Set the hours and minutes for the current date
    currentDate.setHours(hours, minutes, 0, 0);

    if (scheduleType === 'Daily') {
      // Daily: Add daySpan (usually 1 for next day)
      currentDate.setDate(currentDate.getDate() + daySpan);
    }
    else if (scheduleType === 'Weekly' && selectedEmailDay) {
      // Weekly: Find the upcoming selected day of the week
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const selectedDayIndex = daysOfWeek.indexOf(selectedEmailDay);
      if (selectedDayIndex !== -1) {
        const todayIndex = currentDate.getDay();
        let daysToAdd = (selectedDayIndex + 7 - todayIndex) % 7;

        // If today is the same day as the selected day, move to next week's day
        if (daysToAdd === 0) {
          daysToAdd = 7; // Skip to the next occurrence of the same day
        }

        currentDate.setDate(currentDate.getDate() + daysToAdd + daySpan); // Add daySpan if needed
      }
    }
    else if (scheduleType === 'Monthly' && selectedEmailDate) {
      // Monthly: Handle next occurrence of the selected date
      const today = currentDate.getDate();
      if (selectedEmailDate === today) {
        // If today is the same as the selected date, move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
        currentDate.setDate(selectedEmailDate);
      } else if (selectedEmailDate > today) {
        // If the selected date is later this month
        currentDate.setDate(selectedEmailDate);
      } else {
        // If the selected date has already passed, move to next month
        currentDate.setMonth(currentDate.getMonth() + 1);
        currentDate.setDate(selectedEmailDate);
      }
    }

    // Return the formatted date string in 'YYYY-MM-DDTHH:MM:SS' format
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const hoursLocal = String(currentDate.getHours()).padStart(2, '0');
    const minutesLocal = String(currentDate.getMinutes()).padStart(2, '0');
    const secondsLocal = String(currentDate.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hoursLocal}:${minutesLocal}:${secondsLocal}`;
  }

  AddEmailData() {
    // if (!this.validateEmailTimingForm()) {
    //   return;
    // }
    let newobj = {
      GraphConfigId: this.data.GraphConfigId,
      // EmailCustomReportId: 0,
      ReportShiftId: this.selectedreporttiming.value.GraphConfigDetailId,
      ReportShiftName: this.selectedreporttiming.value.GraphConfigName,
      ScheduleType: this.selectedscheduletype.value,

      EmailDate: this.selectedscheduletype.value === 'Monthly' ? (this.EmailTimingForm.value.EmailDate || " ") : " ",
      EmailDay: this.selectedscheduletype.value === 'Weekly' ? (this.selectedemailday ? this.selectedemailday.value : " ") : " ",

      EmailTime: this.EmailTimingForm.value.EmailTime,
      EmailIds: this.EmailTimingForm.value.EmailIds,

      NextSchedule: this.calculateNextSchedule(
        this.EmailTimingForm.value.EmailTime,
        this.selectedscheduletype.value, // ScheduleType (Daily, Weekly, Monthly)
        this.selectedscheduletype.value === 'Daily' ? 1 : 0, // For Daily add 1 day
        this.selectedscheduletype.value === 'Weekly' ? this.selectedemailday.value : undefined, // For Weekly pass the selected email day
        this.selectedscheduletype.value === 'Monthly' ? parseInt(this.EmailTimingForm.value.EmailDate) : undefined // For Monthly pass the selected email date
      ),
      PreviousSchedule: this.calculateNextSchedule(
        this.EmailTimingForm.value.EmailTime,
        this.selectedscheduletype.value,
        0, // For PreviousSchedule use today
        undefined,
        undefined
      ),
      DaySpan: this.selectedscheduletype.value === 'Daily' ? (this.selecteddayspan ? parseInt(this.selecteddayspan.value) : 0) : 0,
      CompanyId: localStorage.getItem('CompanyIdForUC'),
      CompanyCode: localStorage.getItem('CompanyCode'),
      UserId: +localStorage.getItem('UserId'),
    };
    this.EmailConfigList.push(newobj)

  }
  SaveParameterConfigData() {
    var newobj1 =
    {
      listReportConfigDetails: this.GraphConfigList,
      GraphConfigId: this.data.GraphConfigId,
    }
    this.errorMsg = '';
    this.successMsg = '';
    this.errorMsg1 = '';
    this.successMsg1 = '';
    this.adminService.ReportConfigTimingDetails(newobj1).subscribe(
      (result) => {
        this.successMsg = result.Response
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }
  SaveEmailConfigData() {
    var newobj1 =
    {
      listEmailConfigDetails: this.EmailConfigList,
      GraphConfigId: this.data.GraphConfigId,
    }
    this.errorMsg = '';
    this.successMsg = '';
    this.errorMsg1 = '';
    this.successMsg1 = '';
    this.adminService.CustomEmailConfigTimingDetails(newobj1).subscribe(
      (result) => {
        this.successMsg1 = result.Response
      },
      (error) => {
        this.errorMsg1 = error;
      }
    );
  }
  timeChangeHandler(event, isFrom) {

    const date = formatDate(event, 'HH:mm', 'en');

    if (isFrom == 'FromTime') {
      this.ReportTimingForm.patchValue({
        FromTime: date
      });
    }
    if (isFrom == 'ToTime') {

      this.ReportTimingForm.patchValue({
        ToTime: date
      });
    }
    if (isFrom == 'Interval') {
      this.ReportTimingForm.patchValue({
        Interval: date
      });
    }
    if (isFrom == 'EmailTime') {

      this.EmailTimingForm.patchValue({
        EmailTime: date
      });
    }
  }
  OnChangeTimeDuration(e: any) {
    this.selectedtimeduration = e
    if (this.selectedtimeduration != "Daily") {
      this.ReportTimingForm.value.DaySpan == 0
    }
  }


  OnChangeReportTiming(e: any) {
    this.selectedreporttiming = e
  }
  OnChangeScheduleType(e: any) {
    if (e.value === 'Weekly') {
      this.emaildayflag = true;
      this.emaildateflag = false;
      this.dayspanflag = false
    } else if (e.value == 'Daily') {
      this.emaildayflag = false;
      this.emaildateflag = false;
      this.dayspanflag = true

    } else if (e.value == 'Monthly') {
      this.emaildayflag = false;
      this.emaildateflag = true;
      this.dayspanflag = false
    }
    this.selectedscheduletype = e
  }
  OnChangeDaySpan(e: any) {
    this.selecteddayspan = e
  }
  OnChangeEmailTime(e: any) {
    this.selectedemailtime = e
  }
  OnChangeEmailDay(e: any) {
    this.selectedemailday = e
  }
  OnChangeEmailDate(e: any) {
    this.selectedemaildate = e
  }
  onTabChange(e: any) {
    this.getalldata()
  }
}
